module.exports = __webpack_public_path__ + "static/media/pepco_color.fd8277ce.png";